import { httpClient } from '../httpClient';
import {
  IVideoLipsync,
  CreateVideoLipsyncRequest,
  UpdateVideoLipsyncRequest,
  PaginatedResponse,
  VideoLipsyncQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户视频配音 API 模块
 * 处理用户视频配音管理操作
 */
export class VideoLipsyncApi {
  /**
   * 获取用户视频配音分页列表（POST，强类型）
   */
  async videoLipsyncPageList(queryData: PaginationQuery<VideoLipsyncQuery>): Promise<PaginatedResponse<IVideoLipsync>> {
    return httpClient.post<PaginatedResponse<IVideoLipsync>>('/user/videoLipsyncs/page', queryData);
  }

  /**
   * 创建视频配音任务
   */
  async createVideoLipsync(data: CreateVideoLipsyncRequest): Promise<IVideoLipsync> {
    return httpClient.post<IVideoLipsync>('/user/videoLipsyncs', data);
  }

  /**
   * 获取视频配音任务详情
   */
  async getVideoLipsync(id: string): Promise<IVideoLipsync> {
    return httpClient.get<IVideoLipsync>(`/user/videoLipsyncs/${id}`);
  }

  /**
   * 取消视频配音任务
   */
  async cancelVideoLipsync(id: string): Promise<{ cancelled: boolean }> {
    return httpClient.post<{ cancelled: boolean }>(`/user/videoLipsyncs/${id}/cancel`);
  }

  /**
   * 更新视频配音任务
   */
  async updateVideoLipsync(id: string, data: UpdateVideoLipsyncRequest): Promise<IVideoLipsync> {
    return httpClient.put<IVideoLipsync>(`/user/videoLipsyncs/${id}`, data);
  }

  /**
   * 删除视频配音任务
   */
  async deleteVideoLipsync(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/videoLipsyncs/${id}`);
  }
}

// 导出单例实例
export const videoLipsyncApi = new VideoLipsyncApi();